import { render, staticRenderFns } from "./PaymentSalarySlip.vue?vue&type=template&id=f94bc4b0&scoped=true&"
import script from "./PaymentSalarySlip.vue?vue&type=script&lang=js&"
export * from "./PaymentSalarySlip.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSalarySlip.vue?vue&type=style&index=0&id=f94bc4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94bc4b0",
  null
  
)

component.options.__file = "PaymentSalarySlip.vue"
export default component.exports